import '../../scss/app.scss';

require('../app-bootstrap'); // Объявление многих переменных в window

const { useCatalogStore } = require('../storePinia/stores/catalog');

window.App.setStoreModules = function (modules) {
  if (typeof modules === 'object') {
    // eslint-disable-next-line guard-for-in
    for (const key in modules) {
      switch (key) {
        case 'footerMiniBanner':
        case 'personal':
        case 'basket':
        case 'favourite':
          App.store.setStore(key, modules[key]);
          break;
        case 'catalog':
          useCatalogStore().$patch(modules[key]);
          break;
        default:
          console.warn('not registered ', key, modules[key]);
      }
    }
  }
};

App.vue.setComponent(require('@components/Banners/TopMessageBanner').default);
App.vue.setComponent(require('@components/Blog/Header/BlogHeader.vue').default);
App.vue.setComponent(require('@components/Blog/BlogCatalog/BlogCatalog.vue').default);
App.vue.setComponent(require('@components/Blog/Footer/BlogFooter.vue').default);
App.vue.setComponent(require('@components/Blog/BlogDetail/BlogDetail.vue').default);
